import React, { useState, useEffect, use } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'

const InstituteSelectionModal = ({ onClose, show }) => {
  const navigate = useNavigate()
  const [selectInstitute, setSelectInstitute] = useState('') // Initialize as an empty string
  const [institutes, setInstitutes] = useState([]) // Initialize as an empty array to avoid map errors
  const [openModal, setOpenModal] = useState(false)
  // const handleClose = () => {
  //   navigate('/LoginSignup')
  //   setOpenModal(false)
  //   if (onClose) setOpenModal(false)
  // }
  useEffect(() => {
    ApiEndpoints.getAllInstitutes()
      .then((res) => {
        setInstitutes(res.data.data) // Set the list of institutes
      })
      .catch((error) => {
        toast.error('Failed to fetch institutes.')
      })
  }, [])

  const handleSelect = (e) => {
    setSelectInstitute(e.target.value)
  }
  const handleConfirm = async () => {
    console.log('institutes:', institutes) // ✅ Debugging log

    if (!selectInstitute) {
      toast.error('Please select an institute.')
      return
    }

    // Match using `institute_id` instead of `id`
    const institute = institutes.find(
      (inst) => inst?.institute_id?.toString() === selectInstitute?.toString(),
    )

    if (!institute) {
      toast.error('Invalid Institute Selection.')
      return
    }

    // Store in Cookies
    Cookies.set('institute_id', institute.institute_id, { expires: 7 })
    Cookies.set('institute_name', institute.name, { expires: 7 })

    // Navigate to Dashboard
    navigate('/Dashboard')
    onClose()
  }

  return (
    <Modal show centered onHide={onClose}>
      <Modal.Header closeButton className="bg-info text-black">
        <Modal.Title>Select Institute</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Select Institute</Form.Label>
            <Form.Select onChange={handleSelect} value={selectInstitute}>
              <option value="">Select</option>
              {institutes.length > 0 ? (
                institutes.map((inst) => (
                  <option key={inst.institute_id} value={inst.institute_id}>
                    {inst.name}
                  </option>
                ))
              ) : (
                <option disabled>Loading...</option>
              )}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="info" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InstituteSelectionModal
